import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const StakingLoadingOverlay = ({ variant, onDismiss }) => {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);

  const isStakePending = variant === 'stake_pending';
  const isUnstake = variant === 'unstake_processing';

  let title;
  if (isStakePending) {
    title = t('staking.stake_in_progress_title', 'Stake in progress');
  } else if (isUnstake) {
    title = t('staking.unstake_processing_title', 'Processing your Un-Stake request...');
  } else {
    title = t('staking.processing', 'Processing...');
  }

  const subtitle =
    isStakePending
      ? t(
          'staking.stake_in_progress_sub',
          'Your stake will be ready shortly. Do not refresh or close this page!'
        )
      : isUnstake
        ? t('staking.unstake_processing_sub', 'Please wait while the network confirms your request.')
        : null;

  const showDetailsBlock = isStakePending;

  return (
    <div className="staking-loading-overlay" role="status" aria-live="polite">
      <div className="staking-loading-card">
        <div className="staking-loading-dots" aria-hidden>
          {Array.from({ length: 9 }).map((_, i) => (
            <span key={i} className="staking-loading-dot" />
          ))}
        </div>
        <p className="staking-loading-heading">{title}</p>
        {subtitle ? <p className="staking-loading-sub">{subtitle}</p> : null}

        {showDetailsBlock ? (
          <div className="staking-loading-details-wrap">
            <button
              type="button"
              className="staking-loading-details-toggle"
              onClick={() => setShowDetails((s) => !s)}
              aria-expanded={showDetails}
            >
              {showDetails
                ? t('staking.overlay_hide_details', 'Hide details')
                : t('staking.overlay_show_details', 'Show details')}
              <span className="staking-help-chevron">{showDetails ? '▲' : '▼'}</span>
            </button>
            {showDetails ? (
              <p className="staking-loading-details-body">
                {t(
                  'staking.overlay_tx_placeholder',
                  'Transaction details will appear here after contract integration (hash, gas, block).'
                )}
              </p>
            ) : null}
          </div>
        ) : null}

        {onDismiss ? (
          <button type="button" className="staking-btn staking-btn-ghost" onClick={onDismiss}>
            {t('common.close', 'Close')}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default StakingLoadingOverlay;
